/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
//import { Button } from "@mui/material";
import React from "react";
import { URL_BKI } from "../../constants/URL";

export default function EnviarDA (props){
    const{coordX}=props;
    const{coordY}=props;
    const{idOc} = props;
    const{numSerie} = props;

    const sendData = async () => {
        const requestOptions = {
            method: 'POST',
            mode:'cors',
            headers:{   'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/json',
                    },
            body: JSON.stringify({ idOcurrencia: idOc, latitud: coordY, longitud: coordX , numSerie: numSerie})
        };
        await fetch(URL_BKI.ENVIARDA_URL, requestOptions)
        .then(function(response){
            const msg = response.statusText === 'OK' ? 'Satisfactòriament' : 'Insatisfactòriament';
            alert(`El desfibril·lador ${numSerie} amb latitud ${coordY} i longitud ${coordX} ha estat enviat: ${msg}`);
            return response;
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
    };

    React.useEffect(() => {
        sendData();
    }, []);
    
    return(
        //<Button variant="contained" /*onClick={window.location.href='http://localhost:7001/bkint/obtenerDesfibrilador?NumeroDeSerie='+ numSerie +'&fabricante=Heartsine'}*/></Button>
        <div></div>
    );
}